import constants from "../constants";

const {
  GET_ALL_AMENTIES,
  UPDATE_AMENTIES_STORE,
  UPDATE_AMENITY,
  UPDATE_AMENITY_STORE,
  REMOVE_AMENTIES,
  REMOVE_AMENTIES_STORE,
  GET_AMENITY_EVENTS,
  UPDATE_AMENITY_EVENTS_STORE,
  UPDATE_AMENITY_EVENT,
  UPDATE_AMENITY_EVENT_STORE,
  REMOVE_AMENITY_EVENT,
  REMOVE_AMENITY_EVENT_STORE,
} = constants;

// RESERVATIONS
export const getAllAmenities = () => ({
  type: GET_ALL_AMENTIES,
});

export const updateAllAmenitiesStore = (data) => ({
  type: UPDATE_AMENTIES_STORE,
  data,
});
export const updateAmanity = (data) => ({
  type: UPDATE_AMENITY,
  data,
});

export const updateAmenityStore = (amenityData) => ({
  type: UPDATE_AMENITY_STORE,
  amenityData,
});

export const removeAmenities = (data) => ({
  type: REMOVE_AMENTIES,
  data,
});

export const removeAmenitiesStore = (removedIds) => ({
  type: REMOVE_AMENTIES_STORE,
  removedIds,
});

// RESERVATION EVENTS
export const getAmenityEvents = () => ({
  type: GET_AMENITY_EVENTS,
});

export const updateAmenityEventsStore = (data) => ({
  type: UPDATE_AMENITY_EVENTS_STORE,
  data,
});

export const updateAmenityEvent = (data) => ({
  type: UPDATE_AMENITY_EVENT,
  data,
});

export const updateAmenityEventStore = (data) => ({
  type: UPDATE_AMENITY_EVENT_STORE,
  data,
});

export const removeAmenityEvent = (data) => ({
  type: REMOVE_AMENITY_EVENT,
  data,
});

export const removeAmenityEventStore = (data) => ({
  type: REMOVE_AMENITY_EVENT_STORE,
  data,
});
